export const AUTHORS = {
  "shriya-das": {
    slug: "shriya-das",
    name: "Shriya Das",
    role: "Founder and Director",
    photo: "/authors/shriya-das.jpg",
    bio: "Shriya Das is the Founder and Director of IOCRI and a Grade 9 student with a profound academic interest in international relations, organized crime, and transnational security. Driven by intellectual curiosity and a strong research-oriented mindset, she founded International Organized Crime Research Institute with the vision of advancing youth-led research, critical inquiry, and informed dialogue on complex cross-border crime and global security challenges. As Director, Shriya leads the institute's strategic vision and research direction, working to develop International Organized Crime Research Institute as a credible platform for awareness, analysis, and meaningful global engagement.",
    tags: ["International Relations", "Transnational Crime", "Global Security", "Research Leadership"],
  },
  "tarini-seth": {
    slug: "tarini-seth",
    name: "Tarini Seth",
    role: "Co-Founder and Marketing Head",
    photo: "/authors/tarini-seth.jpg",
    bio: "Tarini Seth is a Grade 9 student with an interest in communication, outreach, and digital engagement. At the International Organized Crime Research Institute (IOCRI), she is associated with marketing and networking initiatives, supporting the institute's outreach and digital presence.",
    tags: ["Marketing", "Networking", "Communication", "Community"],
  },
};

export const AUTHORS_LIST = Object.values(AUTHORS);
